import { useRef } from 'react';
import { useQuery } from '@apollo/react-hooks';
import * as AccountQueries from '../__queries__/Account.graphql';
import { currentUserFactory } from './utils';
var EVENT_NAME = 'webskyCurrentUser';
export var useCurrentUser = function (enable) {
    var _a, _b, _c, _d, _e, _f;
    var currentUser = useQuery(AccountQueries.GetUserProfile, {
        skip: !enable
    });
    var userId = useRef(null);
    if (userId.current !== ((_c = (_b = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.data) === null || _a === void 0 ? void 0 : _a.CurrentUser) === null || _b === void 0 ? void 0 : _b.userProfile) === null || _c === void 0 ? void 0 : _c.id)) {
        try {
            var userData = currentUserFactory(currentUser === null || currentUser === void 0 ? void 0 : currentUser.data);
            var event = new CustomEvent(EVENT_NAME, {
                detail: userData
            });
            window[EVENT_NAME] = userData;
            userId.current = (_f = (_e = (_d = currentUser === null || currentUser === void 0 ? void 0 : currentUser.data) === null || _d === void 0 ? void 0 : _d.CurrentUser) === null || _e === void 0 ? void 0 : _e.userProfile) === null || _f === void 0 ? void 0 : _f.id;
            document.dispatchEvent(event);
        }
        catch (e) {
            console.warn(e);
        }
    }
};
